import FormInput from "../FormInput/FormInput";
import React from "react";
export const SnilsInput = (props) => {

    return (
        <FormInput
            {...props}
            useNumberFormat
            format='###-###-### ##'
            allowEmptyFormatting={true}
            mask={"_"}
            hideIcon
        />
    )
}